<button type="button"
  class="artifact-card"
  [class.artifact-card--active]="isActive"
  (click)="onOpen()"
  [attr.aria-pressed]="isActive">

  <span class="artifact-card__icon">
    <i class="pi {{ icon }}" aria-hidden="true"></i>
  </span>

  <span class="artifact-card__text">
    <span class="artifact-card__title">{{ artifact.title }}</span>
    <span class="artifact-card__hint">{{ isActive ? 'Showing in panel' : 'Click to open' }}</span>
  </span>

  <span class="artifact-card__actions">
    @if (canReanalyze) {
      <span class="artifact-card__action" role="button" tabindex="0"
        title="Reanalyze this transcript" aria-label="Reanalyze this transcript"
        (click)="onReanalyze($event)"
        (keydown.enter)="onReanalyze($event)">
        <i class="pi pi-refresh" aria-hidden="true"></i>
      </span>
    }
    @if (artifact.fileUrl) {
      <span class="artifact-card__action" role="button" tabindex="0"
        title="Open in new tab" aria-label="Open in new tab"
        (click)="onOpenNewTab($event)"
        (keydown.enter)="onOpenNewTab($event)">
        <i class="pi pi-external-link" aria-hidden="true"></i>
      </span>
      <span class="artifact-card__action" role="button" tabindex="0"
        title="Download" aria-label="Download"
        (click)="onDownload($event)"
        (keydown.enter)="onDownload($event)">
        <i class="pi pi-download" aria-hidden="true"></i>
      </span>
    }
    <i class="pi pi-angle-right artifact-card__chevron" aria-hidden="true"></i>
  </span>
</button>
